<script setup>
import Header from "@/components/startups/Header.vue";
import {constants} from "@/views/search/manual/searchConstants";
import PulseLoader from "vue-spinner/src/MoonLoader.vue";
import useGrid from "@/composables/useGrid";
import contactsService from "@/services/contacts.service";
import CommonGrid from "@/components/CommonGrid.vue";
import {ref, onMounted} from "vue";
import EditContact from "@/components/contacts/EditContact.vue";

const {items, listLoading, gridParams, gridMethods} = useGrid(getList, 25);

const columns = [
    {
        label: 'Company Name',
        name: 'startup_name',
        filter: 'text',
        component: 'Link',
    },
    {
        label: 'Name',
        name: 'name',
        filter: 'text',
        component: 'Link',
    },
    {
        label: 'Job Title',
        name: 'job_title',
        filter: 'text',
    },
    {
        label: 'Phone',
        name: 'phone',
        filter: 'text',
    },
    {
        label: 'Email',
        name: 'email',
        filter: 'text',
    },
    {
        label: 'LinkedIn',
        name: 'linkedin_url',
        filter: 'text',
        component: 'Link',
    },
    {
        label: 'Notes',
        name: 'notes',
        filter: 'text',
    },
    {
        label: 'User',
        name: 'created_by_user',
        filter: 'text',
    },
    {
        label: 'Ally Type',
        name: 'Ally Type',
        filter: 'text',
    },
    {
        label: 'Country of Origin',
        name: 'Country of Origin',
        filter: 'text',
    },
    {
        label: 'Region of attention',
        name: 'Region of attention',
        filter: 'text',
    },
    {
        label: 'Sector',
        name: 'Sector',
        filter: 'text',
    },
    {
        label: 'LinkedIn Company',
        name: 'LinkedIn Company',
        filter: 'text',
        component: 'Link',
    },
    {
        label: 'Type of relation',
        name: 'Type of relation',
        filter: 'text',
    },
];

const searchString = ref('');
const editContactModal = ref(null);

onMounted(() => {
    gridMethods.setColumns(columns);
    gridMethods.resetList();
});

function getList(pageParams) {
    pageParams.filters.search = searchString.value;

    return contactsService.getMyContacts(pageParams);
}

function gridAction(params) {
    if (params.action === 'edit') {
        editContactModal.value.open(params.rowId);
    }
}

</script>

<template>
    <div>
        <Header/>

        <div class="topbar topbar--search">
            <div class="topbar__inner">
                <div class="topbar__key">
                    <header v-if="gridParams" class="topbar__key__header pl-0">
                        <select
                            v-if="gridParams.totalRowsCount >= gridParams.pageLength"
                            v-model="gridParams.pageLength"
                            class="topbar__key__select"
                        >
                            <option
                                v-for="page in [10,25,50,100,200]"
                                :value="page"
                                :key="page"
                            >
                                {{page}}
                            </option>
                        </select>

                        <template v-else>{{gridParams.totalRowsCount}}</template>

                        of {{gridParams.totalRowsCount.toLocaleString()}} results
                    </header>

                    <div class="form-search-primary-wrapper">
                        <input
                            v-model.trim="searchString"
                            class="form-search-primary"
                            placeholder="Search by Contact name, Position or Notes"
                            v-debounce:500ms.lock="() => gridMethods.resetList()"
                        />
                    </div>

                    <footer class="topbar__key__footer">
                        <span class="topbar__key__label align-self-end">
                            Displaying only contacts added by your company
                        </span>
                    </footer>
                </div>
            </div>
        </div>

        <main class="main main--search main--scrolled">
            <div class="content">
                <div class="content__inner" style="position: relative">
                    <PulseLoader :loading="listLoading" :color="constants.spinnerColor"/>

                    <CommonGrid
                        :columns="gridParams.columns"
                        :items="items"
                        :grid-params="gridParams"
                        :grid-methods="gridMethods"
                        :grid-action="gridAction"
                    />
                </div>
            </div>
        </main>

        <EditContact
            ref="editContactModal"
            @contactSaved="gridMethods.updateList"
        />
    </div>
</template>

<style scoped>

</style>
